import { AppThunk } from '@/store'
import { createActionWithError, request } from '@/store/actions'
import { ADD_MEMBER_TO_SPACE, ADD_MEMBER_TO_SPACE_ERROR } from '@/store/actionTypes'

import {
  ADD_SPACE,
  ADD_SPACE_ADMIN,
  ADD_SPACE_ERROR,
  FETCH_SPACE_MEMBERS,
  REMOVE_SPACE_ADMIN,
  UPDATE_SPACE
} from './actionTypes'

export const addSpaceAndSpaceAdmin = (space: object, currentUser: unknown, spaceAdminRoleId: string): AppThunk => {
  return dispatch => {
    const promise = dispatch(
      request(
        '/organizations/:organizationId/spaces',
        ADD_SPACE,
        { method: 'POST', body: space },
        { args: { organizationId: ':organizationId' }, promisify: true }
      )
    ) as unknown as Promise<any>

    promise
      .then(({ id }) => dispatch(addUserToSpaceAsAdmin(id, currentUser, spaceAdminRoleId)))
      .catch(error => dispatch(createActionWithError(ADD_SPACE_ERROR, {}, error)))
  }
}

export const addUserToSpaceAsAdmin = (spaceId: string, user: any, spaceAdminRoleId: string): AppThunk => {
  return dispatch => {
    const promise = dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/users`,
        ADD_MEMBER_TO_SPACE,
        { method: 'POST', body: user },
        { args: { organizationId: ':organizationId' }, promisify: true }
      )
    ) as unknown as Promise<any>

    promise
      .then(() => dispatch(addSpaceAdmin(spaceId, user.id, [spaceAdminRoleId])))
      .catch(error => dispatch(createActionWithError(ADD_MEMBER_TO_SPACE_ERROR, {}, error)))
  }
}

export const addSpaceAdmin = (spaceId: string, userId: string, roleIdArray: unknown[]): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/roles`,
        ADD_SPACE_ADMIN,
        { method: 'POST', body: { userId, roleIdArray } },
        { args: { organizationId: ':organizationId', spaceId } }
      )
    )
  }
}

export const fetchSpaceMembersInRole = (spaceId: string, role: { id: string }): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/users?roleId=${role.id}`,
        FETCH_SPACE_MEMBERS,
        {},
        { args: { organizationId: ':organizationId', spaceId } }
      )
    )
  }
}

export const removeSpaceAdmin = (spaceId: string, userId: string, roleIdArray: unknown[]): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}/roles`,
        REMOVE_SPACE_ADMIN,
        { method: 'POST', body: { userId, roleIdArray } },
        { args: { organizationId: ':organizationId', spaceId } }
      )
    )
  }
}

export const updateSpace = (spaceId: string, space: object): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/organizations/:organizationId/spaces/${spaceId}`,
        UPDATE_SPACE,
        { method: 'PUT', body: space },
        { args: { organizationId: ':organizationId', spaceId } }
      )
    )
  }
}
